import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import gameService from "services/Game";
import passportService from "services/Passport";
import {
  FETCH_ALL_GAME,
  FETCH_GAME,
  FETCH_LOGIN_GAME,
  FETCH_GAME_TRANSFER,
  FETCH_UPDATE_UNVERIFIED_CONFIG,
} from "constants/ActionTypes";
import {
  gameAllSuccess,
  gameInfoSuccess,
  loginGameSuccess,
  getGameFailed,
  setGameAllowTransfer,
  setUpdateUnverifiedConfig,
} from "actions/Game";
import { showAuthMessage } from "actions/Auth";

const getAllGameRequest = async () =>
  await gameService
    .fetchAll()
    .then((response) => response.json())
    .then((data) => data)
    .catch((error) => error);

const getGameRequest = async (gameID) =>
  await gameService
    .fetchItem(gameID)
    .then((response) => response.json())
    .then((data) => data)
    .catch((error) => error);

const loginRequest = async (loginTypeName, gameID, mapID) =>
  await gameService
    .fetchLogin(loginTypeName, gameID, mapID)
    .then((response) => response.json())
    .then((data) => data)
    .catch((error) => error);

const getGamesTransfer = async (gameID, userID) =>
  await passportService
    .getListGameTransfer({ userID, gameID })
    .then((response) => response.json())
    .then((data) => data)
    .catch((error) => error);

const getUpdateUnverifiedConfigRequest = async () =>
  await gameService
    .fetchUpdateUnverifiedConfig()
    .then((response) => response.json())
    .then((data) => data)
    .catch((error) => error);

function* getAllGame() {
  try {
    const getGame = yield call(getAllGameRequest);
    if (getGame.message) {
      // yield put(showAuthMessage(signInUser.message));
    } else {
      yield put(gameAllSuccess(getGame.data));
    }
  } catch (error) {
    console.log(error);
    // yield put(showAuthMessage(error));
  }
}

function* getGame({ payload }) {
  const { gameID } = payload;
  try {
    const getGame = yield call(getGameRequest, gameID);
    if (getGame.returnCode !== 1) {
      yield put(getGameFailed(getGame));
    } else {
      yield put(gameInfoSuccess(getGame.data));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* loginGame({ payload }) {
  const { loginTypeName, gameID, mapID } = payload;
  try {
    const getGame = yield call(loginRequest, loginTypeName, gameID, mapID);
    if (getGame.message) {
      // yield put(showAuthMessage(signInUser.message));
    } else {
      yield put(loginGameSuccess(getGame.data));
    }
  } catch (error) {
    console.log(error);
    // yield put(showAuthMessage(error));
  }
}

function* getListGameTransfer({ payload }) {
  const { userID, gameID } = payload;
  try {
    const listGame = yield call(getGamesTransfer, gameID, userID);
    if (listGame.returnCode === 1) {
      yield put(setGameAllowTransfer(listGame.data.game));
    } else {
      //yield put(loginGameSuccess(listGame.data.game));
    }
  } catch (error) {
    console.log(error);
    // yield put(showAuthMessage(error));
  }
}

const UPDATE_UNVERIFIED_CONFIG_CACHE_KEY = "updateUnverifiedConfig";

function* fetchUpdateUnverifiedConfig() {
  try {
    const cached = sessionStorage.getItem(UPDATE_UNVERIFIED_CONFIG_CACHE_KEY);
    if (cached) {
      try {
        yield put(setUpdateUnverifiedConfig(JSON.parse(cached)));
        return;
      } catch (_) {
        sessionStorage.removeItem(UPDATE_UNVERIFIED_CONFIG_CACHE_KEY);
      }
    }
    const res = yield call(getUpdateUnverifiedConfigRequest);
    if (res.returnCode === 1) {
      sessionStorage.setItem(UPDATE_UNVERIFIED_CONFIG_CACHE_KEY, JSON.stringify(res.data.gameIds));
      yield put(setUpdateUnverifiedConfig(res.data.gameIds));
    }
  } catch (error) {
    console.log(error);
  }
}

export function* signInUser() {
  yield takeEvery(FETCH_ALL_GAME, getAllGame);
}

export function* getOneGame() {
  yield takeEvery(FETCH_GAME, getGame);
}

export function* logInGame() {
  yield takeEvery(FETCH_LOGIN_GAME, loginGame);
}
// transfer
export function* getGameTransfer() {
  yield takeEvery(FETCH_GAME_TRANSFER, getListGameTransfer);
}

export function* getUpdateUnverifiedConfigSaga() {
  yield takeEvery(FETCH_UPDATE_UNVERIFIED_CONFIG, fetchUpdateUnverifiedConfig);
}

export default function* rootSaga() {
  yield all([
    fork(signInUser),
    fork(getOneGame),
    fork(logInGame),
    fork(getGameTransfer),
    fork(getUpdateUnverifiedConfigSaga),
  ]);
}
